<template>
  <div
    :class="[
      `w-100 d-flex justify-content-${justify} mc-readonly`,
      { 'flex-column': orientation === 'vertical' },
    ]"
  >
    <div
      v-for="(item, idx) in items"
      v-show="item.isShow !== false && item.showComponent !== false"
      :key="idx"
      class="mc-readonly__item"
    >
      <div class="__label">
        {{ item.label }}
      </div>
      <div
        :class="[
          `__value${item.bold ? '-bold' : ''}`,
          item.primaryText ? 'text-secondary' : '',
          item.route ? 'mc-readonly__value--clickable' : '',
        ]"
      >
        <template v-if="'component' in item && item.useComponentOnly !== true">
          <template v-if="item.route">
            <router-link
              :to="item.route"
              class="mc-readonly__link"
              :class="{ 'text-secondary': item.primaryText }"
            >
              {{ item.value }}
            </router-link>
          </template>
          <template v-else>
            {{ item.value }}
          </template>
        </template>
        <template v-else-if="'component' in item && item.useComponentOnly === true">
          <!-- Render only component, skip value text -->
        </template>
        <template v-else>
          <template v-if="item.route">
            <router-link
              :to="item.route"
              class="mc-readonly__link"
              :class="{ 'text-secondary': item.primaryText }"
            >
              {{ item.value }}
            </router-link>
          </template>
          <template v-else>
            {{ item.value }}
          </template>
        </template>
        <a
          v-if="item.value == 'Transit'"
          v-b-tooltip.hover.rightbottom
          title="Pengiriman akan dikirimkan melalui beberapa penugasan (FO), melewati titik transit sebelum mencapai tujuan akhir"
          class="d-inline-flex align-items-center"
        >
          <i id="tooltip-transit" class="mc-fa icon-outline_info mc-tooltip-icon"></i>
        </a>
        <component
          :is="item.component"
          v-if="'component' in item && item.component"
          :detail="detail"
          @additional-act="$emit('additional-act')"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    orientation: {
      type: String,
      default: 'horizontal',
    },
    justify: {
      type: String,
      default: 'between',
    },
    detail: {
      type: Object,
    },
  },
}
</script>

<style lang="scss">
// Techdebt: refactor the hex color as new SCSS variables
.mc-readonly {
  gap: 16px;

  &__item {
    .__label {
      // Secondary/Navy/Navy 40
      color: $mep-color-text-200;
    }

    // color: $secondary;
    .__value {
      // Secondary/Navy/Navy 60
      color: $mep-color-text-300;
      display: flex;
    }
    .__value-bold {
      // Secondary/Navy/Navy 80
      color: $mep-color-text-400;
      font-weight: 600;
    }
  }

  .mc-tooltip-icon {
    font-size: 16px;
    position: relative;
    top: 2px;
  }

  &__value--clickable {
    cursor: pointer;
  }

  &__link {
    text-decoration: none;
    color: inherit;
    transition: opacity 0.15s ease-in-out;
  }
}
</style>
